const config = {
  halal:    { color: "#00C896", bg: "rgba(0,200,150,0.12)",  border: "#00C89633", label: "✓ HALAL",       glow: "0 0 16px rgba(0,200,150,0.3)"  },
  haram:    { color: "#FF4D6D", bg: "rgba(255,77,109,0.12)", border: "#FF4D6D33", label: "✗ HARAM",       glow: "0 0 16px rgba(255,77,109,0.3)"  },
  doubtful: { color: "#FFB830", bg: "rgba(255,184,48,0.12)", border: "#FFB83033", label: "⚠ DOUBTFUL",    glow: "0 0 16px rgba(255,184,48,0.25)" },
  unknown:  { color: "#6B7280", bg: "rgba(107,114,128,0.12)",border: "#6B728033", label: "— UNAVAILABLE", glow: "none" },
  delisted: { color: "#6B7280", bg: "rgba(107,114,128,0.12)",border: "#6B728033", label: "⊘ DELISTED",    glow: "none" },
};

export default function StatusBadge({ status, large }) {
  const c = config[status] || config.doubtful;
  return (
    <span style={{
      padding: large ? "6px 16px" : "3px 10px",
      borderRadius: 30,
      fontSize: large ? 13 : 10,
      fontWeight: 700,
      letterSpacing: "0.06em",
      background: c.bg, color: c.color,
      border: `1px solid ${c.border}`,
      boxShadow: large ? c.glow : "none",
    }}>{c.label}</span>
  );
}
